import { createAsyncThunk } from "@reduxjs/toolkit";

import { addPortCallNotification, getPortCallNotification } from "../../apis/portCallNotification";

export interface PortCallNotificationResult {
  html: string;
  data?: string;
  content?: string;
  body?: string;
  success?: boolean;
  message?: string;
}

export const addPortCallNotificationData = createAsyncThunk("postPortCall/addPortCallNotification", async({ agentOnly, hqOnly, email_introduction, pcid,attachmentList, includeCC }: { agentOnly: boolean; hqOnly: boolean; email_introduction: string; pcid: string, attachmentList:any, includeCC:boolean},
    { rejectWithValue })=>{
    try {
        // Call the correct API function with optional parameters
        const response = await addPortCallNotification({
        agentOnly,
        hqOnly,
        includeCC,
        email_introduction,
        attachmentList,
        pcid,
    });
      return response.data;
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const getPortCallNotificationData = createAsyncThunk<
  PortCallNotificationResult,
  { agentOnly: boolean; hqOnly: boolean; showCompletedBerth: boolean; pcid: string; version?: "v1" | "v2" | "final" }
>(
  "getPortCall/getPortCallNotification",
  async (
    { agentOnly, hqOnly, showCompletedBerth, pcid, version },
    { rejectWithValue }
  ) => {
    try {
      // Pass the parameters to the API function
      const response = await getPortCallNotification({
        agentOnly,
        hqOnly,
        showCompletedBerth,
        pcid,
        version,
      });
      return { html: response.data };
    } catch (error: any) {
      console.error("Error fetching port call notification:", error);
      return rejectWithValue(error.message || "Failed to fetch port call notification");
    }
  }
);
